/*
 * UserProfileMenu Messages
 *
 * This contains all the text for the UserProfileMenu component.
 */
import { defineMessages } from 'react-intl';

const scope = 'userprofilemenu';

export default defineMessages({
  logout: {
    id: `${scope}.logout`,
    defaultMessage: 'Logout',
  },
  theme: {
    id: `${scope}.theme`,
    defaultMessage: 'Theme',
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: 'Back',
  },
  dark: {
    id: `${scope}.dark`,
    defaultMessage: 'Dark',
  },
  light: {
    id: `${scope}.light`,
    defaultMessage: 'Light',
  },
  extraLight: {
    id: `${scope}.extraLight`,
    defaultMessage: 'Extra light',
  },
});
